import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FreeFormAgendaService } from '../service/free-form-agenda.service';
import { DatePipe } from '@angular/common';
import { Globals } from '../service/global';

@Pipe({
  name: 'utcDateConverter'
})
export class UtcDatePipe implements PipeTransform {
    updateTime: any;
    meetingTzName = this.globals.vShortTimeZone;
      constructor(private datepipe:DatePipe,private globals: Globals,private sanitized: DomSanitizer,private commonAgService:FreeFormAgendaService) { }

  transform(utcDate:any) {    
    return this.convertUtc(utcDate);
  }
  //Method to construct agenda section
  convertUtc(agList:any){
    const curSysDate = new Date(agList);
    const tempDate = new Date(curSysDate.getTime());
    const _utcDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(),  tempDate.getUTCHours(), tempDate.getUTCMinutes(), tempDate.getUTCSeconds());
    const meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
    const fullDate = new Date(_utcDate.getTime() + (3600000*(this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
    const hour=this.addZero(fullDate.getHours());
    const minutes=this.addZero(fullDate.getMinutes());
    this.updateTime = hour + ":" + minutes;
    return this.datepipe.transform(fullDate, "MMM dd, YYYY") +"-"+ this.updateTime+ " "+this.meetingTzName;
  }
  addZero(i: any) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }
}
